import { render, staticRenderFns } from "./PolicySignature.vue?vue&type=template&id=5164d20c&scoped=true"
import script from "./PolicySignature.vue?vue&type=script&lang=js"
export * from "./PolicySignature.vue?vue&type=script&lang=js"
import style0 from "./PolicySignature.vue?vue&type=style&index=0&id=5164d20c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5164d20c",
  null
  
)

export default component.exports